module.exports = __webpack_public_path__ + "static/en-logo100-web-white-d0a7a12d9e76965215a9ed1a44505de3.svg";